if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.setupSwipeListeners();
      }

      setupSwipeListeners() {
        this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
        this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });
        this.addEventListener('touchend', this.handleTouchEnd.bind(this));
      }

      handleTouchStart(e) {
        this.touchStartX = e.changedTouches[0].screenX;
      }

      handleTouchMove(e) {
        this.touchEndX = e.changedTouches[0].screenX;
      }

      handleTouchEnd() {
        const swipeThreshold = 50;
        const diff = this.touchStartX - this.touchEndX;

        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            // Swiped left - next image
            this.navigateToNextMedia();
          } else {
            // Swiped right - previous image
            this.navigateToPreviousMedia();
          }
        }
      }

      navigateToNextMedia() {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const currentMedia = this.querySelector('[data-media-id].active');
        const currentIndex = allMedia.indexOf(currentMedia);
        
        if (currentIndex < allMedia.length - 1) {
          const nextMedia = allMedia[currentIndex + 1];
          this.switchToMedia(nextMedia);
        }
      }

      navigateToPreviousMedia() {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const currentMedia = this.querySelector('[data-media-id].active');
        const currentIndex = allMedia.indexOf(currentMedia);
        
        if (currentIndex > 0) {
          const prevMedia = allMedia[currentIndex - 1];
          this.switchToMedia(prevMedia);
        }
      }

      switchToMedia(targetMedia) {
        // Remove active class from all media
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        // Add active class to target media
        const activeMediaTemplate = targetMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        targetMedia.classList.add('active');
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (targetMedia.width - container.clientWidth) / 2;
        }

        if (
          targetMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          targetMedia.loadContent();
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
